import React, { useContext } from 'react';

let contexts = {};

export default function contextGenerator(nameSpace, defaultVal) {
    if (contexts[nameSpace] === undefined) {
        const Context = React.createContext(defaultVal);
        contexts[nameSpace] = {
            Provider: ({ value, children }) => (
                <Context.Provider value={value}>{children}</Context.Provider>
            ),
            useContextValue: () => useContext(Context)
        };
    }
    return contexts[nameSpace];
}

export const nameSpaces = {
    CLIENT_PROMO_JOIN_CHECKER: 'CLIENT_PROMO_JOIN_CHECKER',
    EDITOR_GLOBAL_IMG_CROPPER: 'EDITOR_GLOBAL_IMG_CROPPER',
    EDITOR_PRIMARY_PROMO_DATA: 'EDITOR_PRIMARY_PROMO_DATA'
};
